import {LocationByPlz} from '../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/slForms/getLocationByPlz';
import {SlInput} from '@shoelace-style/shoelace/shoelace';
import {notNull} from '../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert';

/*
 * plz => ort
 * strasse wird ins dsl_connect schnittstelle gesucht beim tippen (vorschlaege werden angezeigt)
 */
export class InternetAddressCompleter {
    private readonly viewRoot: HTMLElement;
    private timerserviceSearch: any;
    private readonly apiUrl: string = '/modulecmsapi/dsl_api_getstrasse/';

    constructor(viewRoot: HTMLElement) {
        const postleitzahl = new LocationByPlz();
        postleitzahl.getLocationByPlz();

        this.viewRoot = viewRoot;
        this.initEventListeners();
    }

    private initEventListeners() {
        this.addEventListenerToStreetInputs();

        // strasse und hausnummer zuruecksetzen, wenn plz geaendert wird
        const plzFields = this.viewRoot.querySelectorAll<SlInput>('.zip');
        plzFields.forEach((plzField) => {
            plzField.addEventListener('sl-change', () => this.resetStreetAndHousenumber());
        });
    }

    private addEventListenerToStreetInputs() {
        const streetInputs = this.viewRoot.querySelectorAll<SlInput>('.consult-availability .street');
        streetInputs.forEach((streetInput: SlInput) => {
            streetInput.addEventListener('sl-input', (e) => this.onStreetInputChange(streetInput as SlInput));
        });
    }

    private onStreetInputChange(field: SlInput) {
        clearTimeout(this.timerserviceSearch);
        if (field.value.length > 2) {
            this.timerserviceSearch = setTimeout(() => {
                this.hideAutocomplete();
                this.fetchStreetData(field);
            }, 200);
        }
    }

    // die felder gibt es mehrmals, deswegen der umweg ueber das array
    private getFieldValue(fields: NodeListOf<SlInput>): string {
        return Array.from(fields).find((field) => field.value !== '')?.value || '';
    }

    private fetchStreetData(field: SlInput) {
        const form = notNull(field.closest('form')) as HTMLFormElement;
        const plzValue = this.getFieldValue(form.querySelectorAll<SlInput>('.zip'));
        const cityValue = this.getFieldValue(form.querySelectorAll<SlInput>('.city'));

        const apiUrl = `${this.apiUrl}?zip=${encodeURI(plzValue)}&city=${encodeURI(cityValue)}&street=${encodeURI(field.value)}`;

        const myHeaders = new Headers({
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        });

        fetch(apiUrl, {
            method: 'GET',
            headers: myHeaders,
            mode: 'cors',
            cache: 'default',
        })
            .then((response) => response.json())
            .then((json) => this.handleFetchedStreetData(json, field));
    }

    private handleFetchedStreetData(json: any, field: SlInput) {
        const streets: string[] = Object.values(json);

        if (streets.length === 0) {
            this.hideAutocomplete();
            return;
        }

        this.showStreetSuggestions(streets, field);
    }

    private showStreetSuggestions(streets: string[], field: SlInput) {
        const autocompletes = this.viewRoot.querySelectorAll<HTMLElement>('.autovervollstandigung');
        const suggestionList = streets.map((street, index) => `<li tabindex="${index}">${street}</li>`).join('');
        const list = `<ul>${suggestionList}</ul>`;

        this.toggleAutocompleteVisibility(autocompletes, true, list);
        this.addAutocompleteListeners(autocompletes, field);
    }

    private toggleAutocompleteVisibility(autocompletes: NodeListOf<HTMLElement>, show: boolean, list: string = '') {
        autocompletes.forEach((autocomplete) => {
            autocomplete.classList.toggle('hidden', !show);
            if (show) autocomplete.innerHTML = list;
        });
    }

    private addAutocompleteListeners(autocompletes: NodeListOf<HTMLElement>, field: SlInput) {
        autocompletes.forEach((autocomplete) => {
            const listItems = autocomplete.querySelectorAll('li');

            // das man mit den pfleiltasten durch die vorschlaege navigieren kann
            listItems.forEach((item) => {
                item.addEventListener('keydown', (e) => this.handleListNavigation(e, field));
                item.addEventListener('click', () => this.selectStreetFromAutocomplete(item));
            });

            // Sicherstellen, dass bei der Anzeige der Liste der Fokus auf das erste Element gesetzt wird
            const firstItem = listItems[0];
            if (firstItem) {
                firstItem.focus();
            }
        });
    }

    private handleListNavigation(e: KeyboardEvent, field: SlInput) {
        const listItems = (e.target as HTMLElement).closest('.form-field')?.querySelector('.autovervollstandigung')?.getElementsByTagName('li') || [];
        const currentIndex = Array.from(listItems).indexOf(document.activeElement as HTMLLIElement);
        const nextIndex = (currentIndex + 1) % listItems.length;
        const prevIndex = (currentIndex - 1 + listItems.length) % listItems.length;

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault(); // Verhindert das Standardverhalten des Browsers (z.B. Scrollen)
                listItems[nextIndex]?.focus(); // Fokus auf das naechste Listenelement setzen
                break;
            case 'ArrowUp':
                e.preventDefault(); // Verhindert das Standardverhalten des Browsers
                listItems[prevIndex]?.focus(); // Fokus auf das vorherige Listenelement setzen
                break;
            case 'Enter':
                e.preventDefault(); // Verhindert das Standardverhalten (z.B. Formularabsendung)
                this.selectStreetFromAutocomplete(listItems[currentIndex]); // Waehlt das aktuelle Listenelement aus
                break;
        }
    }

    private selectStreetFromAutocomplete(item: HTMLLIElement) {
        const streetName = item.innerHTML;

        // die felder gibt es mehrmals (Phone)
        const streets = this.viewRoot.querySelectorAll<SlInput>('.street');
        streets.forEach((street) => (street.value = streetName));

        const fieldset = notNull(document.activeElement).closest('fieldset');
        fieldset?.querySelector<SlInput>('.street_no')?.focus();

        this.hideAutocomplete();
    }

    private hideAutocomplete() {
        const autocompletes = this.viewRoot.querySelectorAll<HTMLElement>('.autovervollstandigung');
        this.toggleAutocompleteVisibility(autocompletes, false);
    }

    private resetStreetAndHousenumber() {
        const streetFields = this.viewRoot.querySelectorAll<SlInput>('sl-input.street');
        const housenrFields = this.viewRoot.querySelectorAll<SlInput>('sl-input.street_no');

        streetFields.forEach((streetField) => {
            streetField.value = '';
        });
        housenrFields.forEach((housenrField) => {
            housenrField.value = '';
        });
    }
}
